export async function createMail(mail) {
    const response = await fetch(process.env.REACT_APP_API_BASE_URL + "mail", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(mail),
    });

    if (response.ok) return response.json();

    throw response;
}
